import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import cx from 'classnames'
import type { ReactNode } from 'react'

import images from 'config/images.json'
import { Picture } from 'src/components/Picture'
import { ImageType } from 'src/components/Picture/Picture.types'
import type { PictureProps } from 'src/components/Picture/Picture.types'

import classes from './styles.module.scss'

type Props = {
  gameProduct: GameProduct
  fullscreen?: boolean
  children?: ReactNode
  className?: string
}

export default function GameBackground(props: Props) {
  const {
    gameProduct: { code, title, type },
  } = props

  const isBingoRoom = type === 'bingo'

  const pictureProps: PictureProps = {
    src: `${images.bucket}/backgrounds/${code}/source.jpg`,
    alt: `background for ${title} game`,
    type: ImageType.BACKGROUND,
    priority: true,
  }

  return (
    <div className={cx(props.fullscreen ? classes.full : classes.root, props.className)}>
      {!isBingoRoom && <Picture {...pictureProps} />}
      {props?.children}
    </div>
  )
}
